import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectSelectedFirestopItemIdToDelete } from '../selectors/firestop-documentation.selectors';
import { patchUpdateFirestopItemAsDeleted } from '../services/patch-update-firestop-item-as-deleted.service';

export const deleteFirestopItem = createAsyncThunk(
  'firestopDocumentation/deleteFirestopItem',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());
    const selectedFirestopItemIdToDelete =
      selectSelectedFirestopItemIdToDelete(getState());

    const updatedFirestopItem = await patchUpdateFirestopItemAsDeleted(
      selectedProjectId,
      selectedFirestopItemIdToDelete
    );

    return updatedFirestopItem;
  }
);
